import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  },
  resources: {
    en: {
      translation: {
        'ear-des': 'Earnings Analysis tool aims to provide a snapshot of year-over-year earnings growth and earnings surprise at a sector level for constituents of select indexes and funds. The goal is provide a picture of trends in earnings and sales in various markets.',
        'sales-surprise-def': 'Sales Surprise: The difference between actual reported sales versus median analyst estimates.',
        'earnings-surprise-def': 'Earnings Surprise: The difference between actual reported earnings versus median analyst estimates.',
        'earnings-growth-def': 'Earnings Growth: Growth in earnings relative to the same period the year prior.',
        'sales-growth-def': 'Sales Growth: Growth in sales relative to the same period the year prior.',
        'periodicity-def': 'Periodicity refers to Quarterly or Annual financial reporting period.',
        'Detail-Attributes': 'Detail Attributes',

        'Sales-Surprise': 'Sales Surprise',
        'Earnings-Surprise': 'Earnings Surprise',
        'Sales-Growth': 'Sales Growth',
        'Earnings-Growth': 'Earnings Growth',
        'sales': 'SALES',
        'cashflow': 'CASH FLOW',
        'operating-earnings': 'OPERATING EARNINGS',
        'Periodicity': 'Periodicity',
        'operating-earnings-def': 'Earnings before interest and taxes.',
        'cashflow-def': 'Operating cash flow.',
        'growth-btn': 'GROWTH (All)',
        'growth-rpt-btn': 'GROWTH (Reported)',
        'surprise-btn': 'SURPRISE',
        'forward-earnings': 'FORWARD ',
        'data': 'DATA',
        'forward-earnings-def': "Forward Earnings is an aggregate of actual company earnings and sales results blended with median analyst estimates for all constituents of respective indexes. It’s a sum of blended actual and estimated earnings and sales for all constituents in the index for each calendar year relative to the prior calendar year. Future conditions are contingent and uncertain.",
        name: 'Name',
        ticker: 'Ticker',
        '1-week': '1-Week',
        MTD: 'MTD',
        '1-month': '1-Month',
        '3-month': '3-Month',
        source: 'Source: WisdomTree, FactSet.',
        since: 'Since',
        stdPerfDisc: "Performance is historical and does not guarantee future results. Current performance may be lower or higher than quoted. Investment returns and principal value of an investment will fluctuate so that an investor's shares, when redeemed, may be worth more or less than their original cost. Performance data for the most recent month-end is available above."
      }
    }
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js